import React, { FC, useState } from 'react'

import { useLocation } from 'react-router-dom'

import {
	PAGE_ASSIGN,
	PAGE_SEARCH_ORGANIZATION,
} from '@app/constants/navigation'
import {
	selectIsSysAdmin,
	selectIsUserAdmin,
	selectOrgAdminStatus,
} from '@app/store/reducers/user/selectors'
import { useDebounce } from '@app/hooks/useDebounce'
import { useTypedSelector } from '@app/hooks/useTypedSelector'
import { SlideMenuBox } from '@app/pages/Dashboard/SideBar/SlideMenu/styled'
import SidebarNavLink from '@app/pages/Dashboard/SideBar/components/SidebarNavLink'
import SlideMenuNav from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuNav/SlideMenuNav'
import { SidebarSearchIcon } from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuNav/styled'
import SlideMenuAccount from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideManuAccount/SlideMenuAccount'
import SlideMenuNavClinicManageTabs from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuNav/SlideMenuNavClinicManageTabs'
import SlideMenuStateButton from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuStateButton/SlideMenuStateButton'

const SlideMenu: FC = () => {
	const location = useLocation()
	const isAdmin = useTypedSelector(selectIsUserAdmin)
	const isSysAdmin = useTypedSelector(selectIsSysAdmin)
	const isOrgAdmin = useTypedSelector(selectOrgAdminStatus)

	const [open, setOpen] = useState<boolean>(false)

	const debouncedOpen = useDebounce(open, 250)

	const handleMouseOver: React.MouseEventHandler<HTMLDivElement> = () => {
		setOpen(true)
	}

	const handleMouseLeave: React.MouseEventHandler<HTMLDivElement> = () => {
		setOpen(false)
	}

	return (
		<SlideMenuBox
			onMouseOver={handleMouseOver}
			onMouseLeave={handleMouseLeave}
			minimize={debouncedOpen}
		>
			<SlideMenuStateButton isOpen={debouncedOpen} />

			<SlideMenuAccount minimize={debouncedOpen} />

			<SlideMenuNav
				locationPathName={location.pathname}
				minimize={!debouncedOpen}
				clinicManageTabsSlot={
					isOrgAdmin && (
						<SlideMenuNavClinicManageTabs
							locationPathName={location.pathname}
							minimize={!debouncedOpen}
						/>
					)
				}
				searchOrgTabSlot={
					isSysAdmin && (
						<SidebarNavLink
							startIconSlot={<SidebarSearchIcon />}
							to={PAGE_SEARCH_ORGANIZATION}
							label={'Search Organization'}
							checked={
								location.pathname === PAGE_SEARCH_ORGANIZATION
							}
						/>
					)
				}
				assignPatientsTabSlot={
					isAdmin && (
						<SidebarNavLink
							to={PAGE_ASSIGN}
							label={'Assign patient to coach'}
							sx={{ mb: 3.5 }}
							checked={location.pathname === PAGE_ASSIGN}
						/>
					)
				}
			></SlideMenuNav>
		</SlideMenuBox>
	)
}

export default SlideMenu
